export default __webpack_public_path__ + "src/assets/linkedin.01d5454ca8e4c78e41c0a82ebb02b153.svg";